module.exports = __webpack_public_path__ + "img/1490373928.7346c243.jpg";